/* KS — AIOD collection backfill
 *
 * Why this exists
 * ---------------
 * AIOD decides whether a Collection-type free-gift rule is met by looking up
 * `window.aiod_collections` (productId -> collection ids). That object is
 * rendered at PAGE LOAD and is not always complete:
 *   - a product added to the cart after load only gets a stub entry, so the
 *     drawer / product page can never satisfy the threshold; and
 *   - some templates render an incomplete list even on a fresh load (2026-08-27:
 *     the home page returned 19 collections for a product and omitted the
 *     campaign's threshold collection, while /cart and /collections/all
 *     returned 20 including it).
 * There is no fallback — `window.aiodGetProductCollections` is a plain lookup
 * into that object, with no Storefront API call behind it.
 *
 * Because the rule has auto_remove_gift = true, an incomplete page does not just
 * fail to add the gift: it REMOVES one the customer already earned. Verified
 * 2026-08-27: gift present on /cart, navigate to /, gift gone within 2.5s.
 *
 * What it does
 * ------------
 * On every AIOD cart-change event, for any cart product missing the threshold
 * collection, read its tags from /products/<handle>.js. If it carries the smart
 * collection's tag, inject the collection id and re-fire the event so AIOD
 * re-evaluates. AIOD then adds the gift itself. No page reload, no drawer churn.
 *
 * Verified 2026-08-27 (cold cart, product page, no navigation):
 *   without this file - no gift after 15s, validGiftRules empty
 *   with this file    - ADD TO CART at 18948ms, patched 20435ms, gift at ~20.5s
 * Also verified on the home page, where AIOD had just judged the rule invalid.
 *
 * MUST be loaded on every page (theme.liquid), never only on cart templates —
 * any page without it will strip the gift again.
 *
 * Keep COLLECTION_ID / TAG in sync with the live AIOD rule. The live value is in
 * window.aiod_free_gift_config[].condition[0][0].extra (label "collection_0"),
 * and TAG is that smart collection's tag condition in Shopify admin.
 *
 * Depends on two AIOD internals (window.aiod_collections and the
 * AIOD_CART_CHANGE_DETECTED event); an app update could rename either. This is a
 * bridge — the underlying bug is AIOD's and should be reported to their support.
 */
(function () {
  var COLLECTION_ID = '524811665621';   // 台美直郵 （Shipping Profile Setting)
  var TAG = '台美直郵預購';               // that smart collection's tag condition
  var seen = {};

  async function backfill() {
    if (!window.aiod_collections) return;
    var cart;
    try {
      cart = await fetch('/cart.js').then(function (r) { return r.json(); });
    } catch (e) { return; }
    var changed = false;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      var pid = String(it.product_id);
      var cols = window.aiod_collections[pid] || [];
      if (cols.indexOf(COLLECTION_ID) !== -1 || seen[pid]) continue;
      seen[pid] = true;                       // also guards against event loops
      var p = await fetch('/products/' + it.handle + '.js')
        .then(function (r) { return r.json(); })
        .catch(function () { return null; });
      if (p && (p.tags || []).indexOf(TAG) !== -1) {
        window.aiod_collections[pid] = cols.concat([COLLECTION_ID]);
        changed = true;
      }
    }
    if (changed) {
      document.dispatchEvent(new CustomEvent('AIOD_CART_CHANGE_DETECTED', { detail: {} }));
    }
  }

  document.addEventListener('AIOD_CART_CHANGE_DETECTED', function () {
    setTimeout(backfill, 400);
  });
  backfill();
})();
